if (!customElements.get('emorpi-rail')) {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const formatMoney = (cents, format) => {
    // Liquid'in yorumlamaması için yer tutucu parçalı yazıldı
    const fmt = format || '{' + '{amount}' + '} TL';
    const n = (cents || 0) / 100;
    const withDelims = (num, decimals, thousands, decimal) => {
      const [int, frac] = num.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: withDelims(n, 2, ',', '.'),
      amount_no_decimals: withDelims(n, 0, ',', '.'),
      amount_with_comma_separator: withDelims(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelims(n, 0, '.', ','),
      amount_with_apostrophe_separator: withDelims(n, 2, "'", '.'),
    })[key] || withDelims(n, 2, ',', '.'));
  };

  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  // Tüm Rail bölümlerinin paylaştığı tek hızlı ekleme penceresi
  class RailQuickAdd {
    constructor() {
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'e-qa';
      this.dialog.setAttribute('aria-label', 'Hızlı sepete ekle');
      document.body.appendChild(this.dialog);
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
    }

    async fetchProduct(handle) {
      const res = await fetch(`${root}products/${handle}.js`);
      if (!res.ok) throw new Error(res.status);
      return res.json();
    }

    // product verilirse tekrar indirilmez (Sepete ekle butonu önceden indirmiş olur)
    // Ürün sayfasındaki beden tablosu (templates/product.emorpi-beden.liquid); ürün başına bir kez indirilir
    async fetchSizeChart(handle) {
      this.sizeCharts = this.sizeCharts || new Map();
      if (this.sizeCharts.has(handle)) return this.sizeCharts.get(handle);
      let html = '';
      try {
        const res = await fetch(`${root}products/${handle}?view=emorpi-beden`);
        const text = res.ok ? await res.text() : '';
        const box = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-e-size]');
        html = box ? box.innerHTML.trim() : '';
      } catch (err) {}
      this.sizeCharts.set(handle, html);
      return html;
    }

    async open(handle, moneyFormat, product) {
      this.moneyFormat = moneyFormat;
      this.dialog.innerHTML = '<button class="e-qa__close" type="button" aria-label="Kapat">×</button><div class="e-qa__loading">Yükleniyor…</div>';
      this.dialog.querySelector('.e-qa__close').addEventListener('click', () => this.dialog.close());
      if (!this.dialog.open) this.dialog.showModal();
      try {
        const [p, chart] = await Promise.all([product || this.fetchProduct(handle), this.fetchSizeChart(handle)]);
        this.product = p;
        this.sizeChart = chart;
      } catch (err) {
        window.location.href = `${root}products/${handle}`;
        return;
      }
      this.kmpNode = null;
      this.sizeOpen = false;
      const first = this.product.variants.find((v) => v.available) || this.product.variants[0];
      this.selected = [...first.options];
      this.qty = 1;
      this.render();
    }

    get variant() {
      return this.product.variants.find((v) => v.options.every((o, i) => o === this.selected[i]));
    }

    isAvailable(optionIndex, value) {
      return this.product.variants.some((v) => v.available && v.options.every((o, i) =>
        i === optionIndex ? o === value : o === this.selected[i]));
    }

    render() {
      const p = this.product;
      const v = this.variant;
      const img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      const hideOptions = p.variants.length === 1 && p.options[0] && p.options[0].name === 'Title';
      const options = hideOptions ? '' : p.options.map((opt, i) => `
        <fieldset class="e-qa__option">
          <legend>${esc(opt.name)}</legend>
          <div class="e-qa__values">
            ${opt.values.map((val) => `
              <button type="button" class="e-qa__value${this.isAvailable(i, val) ? '' : ' is-unavailable'}"
                data-index="${i}" data-value="${esc(val)}" aria-pressed="${this.selected[i] === val}">${esc(val)}</button>`).join('')}
          </div>
        </fieldset>`).join('');

      const price = v
        ? (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price, this.moneyFormat)}</s>` : '') + formatMoney(v.price, this.moneyFormat)
          + (v.compare_at_price > v.price ? ' <span class="e-qa__badge">İndirim</span>' : '')
        : '';
      const canAdd = v && v.available;

      this.dialog.innerHTML = `
        <button class="e-qa__close" type="button" aria-label="Kapat">×</button>
        <div class="e-qa__body">
          <div class="e-qa__media">${img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=800" alt="${esc(p.title)}">` : ''}</div>
          <div class="e-qa__info">
            <h3 class="e-qa__title">${esc(p.title)}</h3>
            <p class="e-qa__price">${price}</p>
            ${options}
            <div class="e-qa__qty">
              <button type="button" data-qty="-1" aria-label="Azalt">−</button>
              <span>${this.qty}</span>
              <button type="button" data-qty="1" aria-label="Artır">+</button>
            </div>
            <div class="e-qa__kmp" data-qa-kmp></div>
            <button type="button" class="e-qa__add" ${canAdd ? '' : 'disabled'}>${canAdd ? 'Sepete Ekle' : (v ? 'Tükendi' : 'Seçenek yok')}</button>
            <p class="e-qa__msg" role="status"></p>
            ${this.sizeChart ? `<details class="e-qa__size"${this.sizeOpen ? ' open' : ''}>
              <summary><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>Beden tablosu</summary>
              <div class="e-qa__size-body">${this.sizeChart}</div>
            </details>` : ''}
            <a class="e-qa__more" href="${root}products/${p.handle}">Ürün detaylarını gör →</a>
          </div>
        </div>`;

      this.dialog.querySelector('.e-qa__close').addEventListener('click', () => this.dialog.close());
      this.placeCampaign();
      this.dialog.querySelectorAll('.e-qa__value').forEach((btn) => btn.addEventListener('click', () => {
        this.selected[+btn.dataset.index] = btn.dataset.value;
        this.render();
      }));
      const size = this.dialog.querySelector('.e-qa__size');
      if (size) size.addEventListener('toggle', () => { this.sizeOpen = size.open; });
      this.dialog.querySelectorAll('[data-qty]').forEach((btn) => btn.addEventListener('click', () => {
        this.qty = Math.max(1, this.qty + +btn.dataset.qty);
        this.dialog.querySelector('.e-qa__qty span').textContent = this.qty;
      }));
      this.dialog.querySelector('.e-qa__add').addEventListener('click', (e) => this.add(e.currentTarget));
    }

    // Ürün sayfasındaki kampanya çubuğu (3 Al 2 Öde + otomatik kademe indirimleri): sayfadaki şablondan bir kez
    // kopyalanır (stiliyle birlikte), beden değişince yeniden çizilen pencerede aynı çubuk yerine taşınır
    placeCampaign() {
      const slot = this.dialog.querySelector('[data-qa-kmp]');
      const tpl = document.getElementById('e-qa-kampanya');
      if (!slot) return;
      if (!this.kmpNode && tpl) {
        const frag = tpl.content.cloneNode(true);
        frag.querySelectorAll('link, script').forEach((n) => n.remove());
        if (frag.querySelector('emorpi-kampanya')) {
          this.kmpNode = document.createElement('div');
          this.kmpNode.append(frag);
        }
      }
      if (this.kmpNode) slot.append(this.kmpNode);
      else slot.remove();
    }

    // Sepete ekler; Dawn sepet çekmecesi varsa onu açar ve true döner,
    // yoksa yalnızca sepet simgesindeki sayıyı günceller
    async addToCart(id, quantity) {
      const drawer = document.querySelector('cart-drawer');
      const notification = document.querySelector('cart-notification');
      const target = drawer || notification;
      const sections = target && target.getSectionsToRender
        ? target.getSectionsToRender().map((s) => s.id)
        : ['cart-icon-bubble'];

      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity, sections, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Eklenemedi');

      if (target && target.renderContents) {
        if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        if (this.dialog.open) this.dialog.close();
        target.renderContents(data);
        return true;
      }

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        const inner = html.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      return false;
    }

    // Rail'deki Sepete ekle butonu: tek seçenekli ürün doğrudan eklenir,
    // beden/renk seçimi olan ürün için seçim penceresi açılır
    // done: bitince butonu o an öndeki ürüne göre yeniden ayarlar
    async buy(handle, moneyFormat, button, done) {
      const label = button.textContent;
      const restore = (delay) => setTimeout(() => {
        button.disabled = false;
        button.textContent = label;
        if (done) done();
      }, delay);
      button.disabled = true;
      button.textContent = 'Ekleniyor…';

      let product;
      try {
        product = await this.fetchProduct(handle);
      } catch (err) {
        window.location.href = `${root}products/${handle}`;
        return;
      }

      const single = product.variants.length === 1;
      if (!single) {
        restore(0);
        this.open(handle, moneyFormat, product);
        return;
      }

      const v = product.variants[0];
      if (!v.available) {
        button.textContent = 'Tükendi';
        restore(1600);
        return;
      }
      try {
        const drawerOpened = await this.addToCart(v.id, 1);
        button.textContent = drawerOpened ? label : 'Sepete Eklendi ✓';
        restore(drawerOpened ? 0 : 1600);
      } catch (err) {
        button.textContent = err.message || 'Eklenemedi';
        restore(2200);
      }
    }

    async add(button) {
      const v = this.variant;
      if (!v) return;
      const msg = this.dialog.querySelector('.e-qa__msg');
      button.disabled = true;
      button.textContent = 'Ekleniyor…';
      msg.textContent = '';

      try {
        if (await this.addToCart(v.id, this.qty)) return;
        msg.innerHTML = `Sepete eklendi. <a href="${root}cart">Sepete git</a>`;
        button.textContent = 'Sepete Eklendi';
        setTimeout(() => { button.disabled = false; button.textContent = 'Sepete Ekle'; }, 1600);
      } catch (err) {
        msg.textContent = err.message;
        button.disabled = false;
        button.textContent = 'Sepete Ekle';
      }
    }
  }

  // Ürün kartlarındaki (koleksiyon, ana sayfa listeleri) "Sepete ekle": Dawn'ın ürün sayfası kadar uzun
  // penceresi yerine bu kısa pencere açılır. Dawn'ın kendi dinleyicisinden önce yakalamak için capture aşamasında.
  const quickAdd = () => (window.emorpiRailQuickAdd = window.emorpiRailQuickAdd || new RailQuickAdd());
  document.addEventListener('click', (e) => {
    // Tema düzenleyicide de: Dawn'ın penceresi artık kartlarda yok (snippets/card-product.liquid)
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    const btn = e.target.closest('modal-opener[data-modal^="#QuickAdd-"] button');
    const card = btn && btn.closest('.card-wrapper, .card');
    const link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return;
    const handle = new URL(link.href, location.origin).pathname.split('/products/')[1]?.split('/')[0];
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    quickAdd().open(decodeURIComponent(handle), (window.emorpiQA && emorpiQA.moneyFormat) || '');
  }, true);

  customElements.define('emorpi-rail', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.e-rail__item')];
      this.info = this.querySelector('.e-rail__info');
      this.titleEl = this.querySelector('[data-rail-title]');
      this.priceEl = this.querySelector('[data-rail-price]');
      this.viewport = this.querySelector('.e-rail__viewport');
      if (!this.items.length) return;

      const touch = matchMedia('(hover: none)').matches;
      const quickAdd = this.dataset.quickAdd === 'true' && !window.Shopify?.designMode;

      this.items.forEach((item, i) => {
        item.addEventListener('focus', () => this.activate(i));
      });

      // mouseenter yerine gerçek fare hareketi: askılar genişleyip kayınca
      // imlecin altına başka ürün gelse bile seçim kendiliğinden değişmez
      this.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const item = e.target.closest('.e-rail__item');
        if (item) this.activate(this.items.indexOf(item));
      });

      // Ürün basılınca genişleyip kaydığı için bırakma başka yere düşebilir;
      // tıklamayı basılan askıya bağla
      this.addEventListener('pointerdown', (e) => {
        this.pressed = e.target.closest('.e-rail__item');
      });
      this.addEventListener('click', (e) => {
        const item = e.target.closest('.e-rail__item') || (e.target.closest('.e-rail__track') && this.pressed);
        this.pressed = null;
        if (!item || e.metaKey || e.ctrlKey || e.shiftKey) return;
        const i = this.items.indexOf(item);
        e.preventDefault();
        // Dokunmatikte ilk dokunuş ürünü öne çevirir
        if (touch && this.active !== i) {
          this.activate(i, true);
          return;
        }
        if (quickAdd && item.dataset.handle) {
          window.emorpiRailQuickAdd = window.emorpiRailQuickAdd || new RailQuickAdd();
          window.emorpiRailQuickAdd.open(item.dataset.handle, this.dataset.moneyFormat);
        } else if (!window.Shopify?.designMode && item.href && !item.href.endsWith('#')) {
          window.location.href = item.href;
        }
      });

      // Dokunmatikte kaydırırken ortaya gelen askı anında öne döner;
      // kaydırma durunca seçili askı tam ortaya oturur
      if (touch) {
        let frame = 0;
        this.viewport.addEventListener('scroll', () => {
          if (Date.now() < this.lockUntil) return;
          if (!frame) {
            frame = requestAnimationFrame(() => {
              frame = 0;
              const i = this.indexAt(this.viewport.scrollLeft);
              if (i !== this.active) this.activate(i);
            });
          }
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            if (Date.now() >= this.lockUntil) this.center(this.active, true);
          }, 140);
        }, { passive: true });
      }

      // Masaüstü okları: görünen alanın büyük kısmı kadar kaydırır,
      // durunca ortadaki askı öne döner
      this.prevBtn = this.querySelector('[data-rail-prev]');
      this.nextBtn = this.querySelector('[data-rail-next]');
      if (this.prevBtn && this.nextBtn) {
        const page = (dir) => {
          this.paging = true;
          this.viewport.scrollBy({ left: dir * this.viewport.clientWidth * 0.7, behavior: 'smooth' });
        };
        this.prevBtn.addEventListener('click', () => page(-1));
        this.nextBtn.addEventListener('click', () => page(1));
        const update = () => {
          const max = this.viewport.scrollWidth - this.viewport.clientWidth;
          this.classList.toggle('has-overflow', max > 4);
          this.prevBtn.disabled = this.viewport.scrollLeft < 4;
          this.nextBtn.disabled = this.viewport.scrollLeft > max - 4;
          if (this.paging) {
            clearTimeout(this.pageTimer);
            this.pageTimer = setTimeout(() => {
              this.paging = false;
              this.activate(this.indexAt(this.viewport.scrollLeft));
            }, 120);
          }
        };
        this.viewport.addEventListener('scroll', update, { passive: true });
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.items[0].parentElement);
        }
        update();
      }

      this.cartBtn = this.querySelector('[data-rail-cart]');
      if (this.cartBtn) {
        this.cartBtn.addEventListener('click', () => {
          const item = this.items[this.active];
          if (!item || !item.dataset.handle || this.cartBtn.disabled) return;
          // Tema düzenleyicide sepete ekleme yapılmaz
          if (window.Shopify?.designMode) return;
          window.emorpiRailQuickAdd = window.emorpiRailQuickAdd || new RailQuickAdd();
          window.emorpiRailQuickAdd.buy(item.dataset.handle, this.dataset.moneyFormat, this.cartBtn,
            () => this.updateCart(this.items[this.active]));
        });
      }

      this.reflEl = this.querySelector('[data-rail-refl]');
      this.lightsBtn = this.querySelector('[data-rail-lights]');
      if (this.lightsBtn) {
        this.lightsLabel = this.lightsBtn.querySelector('[data-rail-lights-label]');
        this.labels = { off: this.lightsLabel.textContent, on: this.dataset.lightsOnLabel || this.lightsLabel.textContent };
        this.lightsBtn.addEventListener('click', () => this.setDark(!this.classList.contains('is-dark')));
        ['pointerenter', 'focus', 'touchstart'].forEach((type) => this.lightsBtn.addEventListener(type, () => this.loadGlow(), { once: true, passive: true }));
      }

      const startSetting = parseInt(this.dataset.start || '0', 10);
      const start = startSetting === 0
        ? Math.floor((this.items.length - 1) / 2)
        : Math.min(startSetting, this.items.length) - 1;
      this.activate(start, false, true);

      // Bu koleksiyonun ışıkları (burada ya da koleksiyon sayfasında) kapatıldıysa karanlık başla
      if (this.lightsBtn && this.dataset.lightsKey) {
        try {
          if (sessionStorage.getItem(this.dataset.lightsKey) === 'off') this.setDark(true, false);
        } catch (e) {}
      }

      // Müşteri askıda 5 ürün sağa kaydırınca ışıklar kendiliğinden kapanır (far geçişiyle).
      // Oturumda koleksiyon başına bir kez; müşteri ışığı kendi açıp kapattıysa dokunulmaz.
      if (this.lightsBtn && this.dataset.lightsKey && !window.Shopify?.designMode) {
        const key = this.dataset.lightsKey;
        const autoKey = key.replace('emorpi-lights:', 'emorpi-lights-auto:');
        const untouched = () => {
          try {
            return sessionStorage.getItem(key) === null && !sessionStorage.getItem(autoKey);
          } catch (e) {
            return false;
          }
        };
        if (untouched()) {
          const onScroll = () => {
            if (this.indexAt(this.viewport.scrollLeft) - start < 5) return;
            this.viewport.removeEventListener('scroll', onScroll);
            if (this.classList.contains('is-dark') || !untouched()) return;
            try {
              sessionStorage.setItem(autoKey, '1');
            } catch (e) {}
            this.setDark(true);
          };
          this.viewport.addEventListener('scroll', onScroll, { passive: true });
        }
      }

      // Tema düzenleyicide blok seçilince o askıyı öne çevir
      this.onBlockSelect = (e) => {
        const i = this.items.findIndex((el) => el.contains(e.target) || e.target.contains(el));
        if (i > -1) this.activate(i, true);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    // Askı i öndeyken ortalanmış hâlinin kaydırma konumu. Öndeki askı ne olursa olsun
    // önceki askılar hep yan duruşta olduğundan bu konum i ile doğrusal artar;
    // genişlik animasyonunun bitmesini beklemeden hesaplanabilir.
    railMetrics() {
      const cs = getComputedStyle(this);
      const full = parseFloat(cs.getPropertyValue('--rail-item-w'));
      const side = full * parseFloat(cs.getPropertyValue('--rail-side'));
      const gap = parseFloat(getComputedStyle(this.items[0].parentElement).columnGap) || 0;
      const base = this.items[0].offsetLeft + full / 2 - this.viewport.clientWidth / 2;
      return { base, step: side + gap };
    }

    indexAt(scrollLeft) {
      const { base, step } = this.railMetrics();
      const i = Math.round((scrollLeft - base) / step);
      return Math.max(0, Math.min(this.items.length - 1, i));
    }

    // Sayfayı dikeyde oynatmadan askıyı yatayda ortala
    center(i, smooth) {
      const { base, step } = this.railMetrics();
      const left = Math.max(0, base + i * step);
      if (Math.abs(this.viewport.scrollLeft - left) < 2) return;
      // Ortalama kaydırması sürerken kaydırmaya göre seçim yapılmasın
      this.lockUntil = Date.now() + (smooth ? 700 : 100);
      this.viewport.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
    }

    // Işıkları kapatınca far ışığı askıların üzerinden soldan sağa geçer;
    // her reflektör, ışık üstüne geldiği anda parlamaya başlar
    // Parlama görselleri sayfa açılışında indirilmez; düğmeye yaklaşınca ya da ilk karartmada yüklenir
    loadGlow() {
      this.querySelectorAll('img.e-rail__glow[data-srcset]').forEach((img) => {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      });
    }

    setDark(on, animate = true) {
      if (on) this.loadGlow();
      const track = this.querySelector('.e-rail__track');
      const beam = this.querySelector('.e-rail__beam');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const sweep = reduced || !animate ? 0 : 1600;
      const width = track.scrollWidth;

      this.items.forEach((el) => {
        const center = el.offsetLeft + el.offsetWidth / 2;
        const delay = on && sweep ? Math.round(sweep * (0.1 + 0.8 * center / width)) : 0;
        el.style.setProperty('--glow-delay', delay + 'ms');
      });

      this.classList.toggle('is-dark', on);
      this.lightsBtn.setAttribute('aria-checked', String(on));
      this.lightsLabel.textContent = on ? this.labels.on : this.labels.off;
      if (this.dataset.lightsKey) {
        try {
          sessionStorage.setItem(this.dataset.lightsKey, on ? 'off' : 'on');
        } catch (e) {}
      }

      this.classList.remove('is-sweeping');
      if (on && sweep && beam) {
        this.style.setProperty('--sweep', sweep + 'ms');
        this.style.setProperty('--beam-end', (width + beam.offsetWidth) / beam.offsetWidth * 100 + '%');
        void beam.offsetWidth;
        this.classList.add('is-sweeping');
      }
      this.updateRefl(this.items[this.active]);
    }

    // Ürünü olmayan askıda buton gizlenir, stokta olmayanda "Tükendi" yazar
    updateCart(item) {
      const btn = this.cartBtn;
      if (!btn || !item) return;
      btn.hidden = !item.dataset.handle;
      const available = item.dataset.available === 'true';
      btn.disabled = !available;
      btn.textContent = available ? btn.dataset.label : btn.dataset.soldOut;
    }

    updateRefl(item) {
      if (!this.reflEl || !item) return;
      const yes = item.dataset.reflective === 'true';
      const dark = this.classList.contains('is-dark');
      this.reflEl.textContent = yes ? this.reflEl.dataset.yes : (dark ? this.reflEl.dataset.no : '');
      this.reflEl.classList.toggle('is-on', yes);
      this.reflEl.classList.toggle('is-off', !yes);
    }

    activate(i, scroll = false, initial = false) {
      if (this.active === i) return;
      this.active = i;
      this.classList.add('has-active');
      this.items.forEach((el, j) => el.classList.toggle('is-active', j === i));

      const item = this.items[i];
      if (!initial) {
        item.classList.remove('is-swinging');
        void item.offsetWidth;
        item.classList.add('is-swinging');
        item.addEventListener('animationend', () => item.classList.remove('is-swinging'), { once: true });
      }

      if (scroll || initial) this.center(i, !initial);

      const apply = () => {
        this.titleEl.textContent = item.dataset.title || '';
        this.priceEl.innerHTML = item.dataset.price || '';
        this.updateRefl(item);
        this.updateCart(item);
        this.info.classList.remove('is-changing');
      };
      if (initial) return apply();
      this.info.classList.add('is-changing');
      clearTimeout(this.swapTimer);
      this.swapTimer = setTimeout(apply, 180);
    }
  });
}
